<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed? 0: 5" :sm="24" class="new-col">
      <a-card :bordered="false" class="new-tree-card">
        <!-- 按钮操作区域 -->
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
            </div>
          </a-alert>
          <div style="display: flex;margin-top: 10px;">
            <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
            <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
          </div>
          <!-- 树-->
          <a-col :md="24" :sm="24" class="new-tree-col">
            <template>
              <a-spin tip="Loading..." :spinning="areaLoading">
                <!--
                <span style="user-select: none">
                  <a-tree
                    class="my-area-select-tree"
                    @select="onSelect"     
                    :selectedKeys="selectedKeys"
                    :treeData="areaTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    defaultExpandParent
                    @expand="onExpand">
                    <template slot="title" slot-scope="{title}">
                      <span v-if="title.indexOf(searchAreaValue) > -1">
                        {{title.substr(0, title.indexOf(searchAreaValue))}}
                      <span style="color: #32CD32">{{searchAreaValue}}</span>
                        {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                      </span>
                      <span v-else>{{title}}</span>
                    </template>
                  </a-tree>
                </span>
                -->
                <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
              </a-spin>
            </template>
          </a-col>
        </div>
      </a-card>
    </a-col>
    <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
      <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
        @click="collapsed = !collapsed"
        class="area-collapsed"></a-icon>
      <a-card :bordered="false" class="new-table-card">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('查询日期')">
                  <a-month-picker
                    v-model="queryParam.reportDate"
                    format="YYYY-MM"
                    :placeholder="$t('请选择查询日期')"
                    valueFormat="YYYY-MM"
                    @ok="onOk"
                  />
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('价格名称')">
                  <a-select v-model="queryParam.waterTypeId" :placeholder="$t('请选择价格名称')">
                    <a-select-option v-for="data in userPriceCode" :key="data.id" :value="data.id">
                      {{data.wtName}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <!--
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="操作类型">
                  <a-select
                  mode="multiple"
                  v-model="genre"
                  style="width: 100%"
                  placeholder="请选择操作类型"
                  @change="handleChange"
                >
                  <a-select-option v-for="(item,value) in payTypeObj" :value="value" :key="value">
                    {{item}}
                  </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              -->
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('操作员')">
                  <a-select v-model="queryParam.createBy" :placeholder="$t('请选择操作员')">
                    <a-select-option v-for="data in userArray" :key="data.username" :value="data.username">
                      {{data.username}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                  <!--
                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a>
                  -->
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
          <a-button type="primary" icon="download" @click="handleExportXls($t('月报表'))">{{ $t('导出') }}</a-button>
        </div>
        <div class="flex flex-center" style="margin-bottom: 15px;position: relative;">
          <div class="flex-item" style="height: 80px" v-for="item in totalList" :key="item.key">
            <div class="flex-center" style="height: 100%;background: #e6f7ff;border: 1px solid #91d5ff;flex-direction: column;">
              <div class="flex-center">
                <span class="" style="margin-left:10px;font-size:24px;font-weight: 500">{{item.key ==1?item.num:towNumber(item.num)}}</span>
                <span class="unit" style="color: #999999">{{ $t(item.unit) }}</span>
              </div>
              <div class="flex-center" style="color: #999999">{{ $t(item.title) }}</div>
            </div>
          </div>
          <div class="example" v-if="loading">
              <a-spin :spinning="loading" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);"></a-spin>
          </div>
        </div>
        <div class="table-fixed">
          <a-table
            ref="table"
            size="middle"
            :scroll="{x:true}"
            bordered
            rowKey="reportMonth"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange">

            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">{{ $t('详情') }}</a>
            </span>
          </a-table>
        </div>
        <meter-monthly-statement-modal ref="modalForm" @ok="modalFormOk"></meter-monthly-statement-modal>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import MeterMonthlyStatementModal from './modules/MeterMonthlyStatementModal'
  import { listSize } from '@/utils/util'
  import { getAction } from '@/api/manage'
  import moment from 'moment'
  import {payTypeObj} from '@/utils/constants/commonConstant'
  import { mapGetters } from 'vuex'
  import {isUndefinedAndNull} from '@/utils/validate'

  export default {
    name: 'MeterMonthlyStatementList',
    mixins:[JeecgListMixin, mixinDevice, AreaChoosetMixin],
    components: {
      MeterMonthlyStatementModal
    },
    data () {
      return {
        description: '月销售报表',
        collapsed: false,
        currSelected: {},
        payTypeObj,
        userPriceCode:[],  //用水性质
        userArray:[],  //操作员
        genre:[],  //操作类型
        //列设置
        settingColumns:[],
        url: {
          list: "/jeecg-charge/meter/meterUserPayRecord/monthReportSum", //月报表列表
          delete: "/jeecg-charge/meter/meterUserWaterReportDay/delete",
          deleteBatch: "/jeecg-charge/meter/meterUserWaterReportDay/deleteBatch",
          exportXlsUrl: "jeecg-charge/meter/meterUserWaterReportDay/exportXlsForMonthUseList",
          importExcelUrl: "/jeecg-charge/meter/meterUserWaterReportDay/importExcel",
          userPriceCode:"/jeecg-charge/meter/meterPriceinfo/list",  // 用水性质
          dayReportSum:"/jeecg-charge/meter/meterUserPayRecord/queryMonthReportSumTotal", //汇总报表
          user: "/sys/user/departUserList",  //操作员列表
          deptList: "/sys/sysDepart/getDepartName"
        },
        dictOptions:{},
        date: null,
        totalList: [
          {key: 1,title: this.$t('记录条数'),num: '',unit: '条'},
          {key: 2,title: this.$t('充值金额'),num: '',unit: '元'},
          {key: 3,title: this.$t('退费金额'),num: '',unit: '元'},
          {key: 4,title: this.$t('营收金额'),num: '',unit: '元'}

        ]
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
      this.loadData(1);
      this.queryUserPriceCode();
      this.queryUserList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：列定义使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            },
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            }
          },{
            title: this.$t('日期'),
            align:"center",
            dataIndex: 'reportMonth'
          },{
            title: this.$t('记录条数'),
            align:"center",
            dataIndex: 'dayRecordCount'
          },{
            title: this.$t('退费金额(元)'),
            align:"center",
            dataIndex: 'daySumBack'
          },{
            title: this.$t('充值金额(元)'),
            align:"center",
            dataIndex: 'daySumPay'
          },{
            title: this.$t('营收金额(元)'),
            align:"center",
            dataIndex: 'daySumRevenue'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:100,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      ...mapGetters(["userInfo"]),
      handleChange(value) {
        this.queryParam.userAccountPayType = value + '';
      }, 
      querydayReportSum() {   //汇总报表
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        // params.userAccountPayType = this.genre.type;
        //params.reportDate = this.date;
        getAction(this.url.dayReportSum, params).then((res) => {
          console.log(res);
          if(res.success ){
            this.totalList[0].num = res.result.dayRecordCount
            this.totalList[1].num = res.result.daySumPay
            this.totalList[2].num = res.result.daySumBack
            this.totalList[3].num = res.result.daySumPay - res.result.daySumBack;
          }
        })
      },
      queryUserPriceCode() {  //用水性质请求
        let params = {};
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userPriceCode, params).then((res) => {
          if(res.success){
            this.userPriceCode = res.result.records;
            console.log(this.userPriceCode);
          }
        }) 
      },
      queryUserList() { //操作员请求
        getAction(this.url.deptList, {pageNo: 1,pageSize: 1,orgCode: this.userInfo().orgCode}).then((res) => {
          if(res.success&&res.result.id){
            let params = {}
            params.pageNo = 1;
            params.pageSize = listSize;
            console.log(this.userInfo())
            params.depId = res.result.id;
            getAction(this.url.user, params).then((res) => {
              if(res.success){
                this.userArray = res.result.records;
                console.log(this.userArray);
              }
            }) 
          }
        })
      },
      loadListData(arg) {
        if(!this.url.list){
          this.$message.error(this.$t('请设置url.list属性!'));
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        console.log(this.queryParam);
        this.loading = true;
        // params.userAccountPayType = this.genre.type;

        //params.reportDate = this.date;
        getAction(this.url.list, params).then((res) => {
          console.log(res.result.records);
          if (res.success) {
            this.dataSource = res.result.records;
            console.log(this.dataSource);
            this.ipagination.total = res.result.total;
          }
          if(res.code===510){
            this.$message.warning(res.message);
          }
          this.loading = false;
        })
      },
      // querymonthReportSum() {   //汇总报表
      //   var params = this.getQueryParams();//查询条件
      //   this.loading = true;
      //   params.userAccountPayType = this.genre.type;
      //   params.reportDate = this.dateString;
      //   getAction(this.url.monthReportSum, params).then((res) => {
      //     if(res.success ){
      //       console.log(res.result);
      //       this.collect = res.result;
      //       console.log(this.collect);
      //       // this.collect.daySumRevenue = this.collect.daySumPay - this.collect.daySumBack;
      //     }
      //   })
      // },
      towNumber(val) {    //保留两位小数
        if (!val) {
          return 0;
        }
        return val.toFixed(2);  
      },
      handleEdit(record) {
      this.$refs.modalForm.edit(this.queryParam,record);
      this.$refs.modalForm.title = this.$t("详情");
      },
      onChange(value, dateStrings) {
        if(!isUndefinedAndNull(dateStrings)&&dateStrings!=='') {
          this.date = moment(dateStrings).format('YYYY-MM');
        }
      },
      onOk(value) {
        console.log('onOk:', value);
      },
      loadData(arg) {
        this.querydayReportSum();
        this.loadListData(arg);
      },
      handleTableChange(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.loadListData();
      },
      searchReset() {
        this.queryParam = {}
        this.resetAareaData()
        this.date = this.$options.data.call(this).date
        this.genre  = []
        this.loadData(1);
      },
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
  .example {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    background-color: rgba(230, 247, 255, 0.7);
    width: 100%;
    height: 100%;
  }
</style>